<template>
  <modal :title="title" ref="modal">
    <div class="text-body1">
      <ServiceAccount v-model:service-account="serviceAccount" />
    </div>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import Modal from '@/components/modal/Modal.vue';
import { IntegrationConnection, ServiceAccount as ServiceAccountType } from '@/iam/types';
import ServiceAccount from '../service-account/ServiceAccount.vue';

interface Data {
  serviceAccount: ServiceAccountType
}

export default defineComponent({
  emits: ['ok'],
  mixins: [ModalMixin],
  components: {
    ServiceAccount,
    Modal,
  },
  props: {
    connection: {
      type: Object as () => IntegrationConnection,
      required: true,
    },
  },
  data(): Data {
    return {
      serviceAccount: this.connection.serviceAccount,
    };
  },
  computed: {
    title(): string {
      return this.serviceAccount.label;
    },
  },
  watch: {
    serviceAccount(serviceAccount: ServiceAccountType): void {
      this.$emit('ok', { ...this.connection, serviceAccount });
    },
  },
});
</script>
